import { render, staticRenderFns } from "./LegalDocumentation.vue?vue&type=template&id=6c5ac26c&"
import script from "./LegalDocumentation.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports